export enum cacheKeysEnum {
    applicationGuid = 'applicationGuid',
    reloadFlagKey = 'onboardStudentPageReloaded',
    studentDetails = 'studentDetails'
}